module.exports = __webpack_public_path__ + "media/images/icons/icon-feature-performance-1ec7483cd25ec011749fc48912c1cbcb.svg";